import React from 'react';
import './../index.css';

export class LevelMovies extends React.Component {

  onClick(url) {
    window.open(url, "_blank");
  }

  render() {
    const movies = this.props.movies;
    return (
      <>
        {
          /*
          * Level Movies section
          */
        }
        {movies &&
          <div className='levelBooks'>
            {
              movies.map(
                currentMovie =>
                  <p>
                    <p style={{ padding: '1vw' }}>
                      {currentMovie.text}
                    </p>
                    <img alt='' src={currentMovie.image} />
                    <p>
                      <input className='openButton' type='button' onClick={() => this.onClick(currentMovie.url)}
                        value='Click here to purhase' />
                    </p>
                  </p>
              )
            }

          </div>

        }
      </>
    );
  }


}
